export default __webpack_public_path__ + "static/media/google-play-badge.24fd9809.svg";